export type AutosaveState = {
  commentDrafts: AutosavedDraft[];
  messageDrafts: AutosavedDraft[];
};
type State = { drafts: AutosaveState };

export const draftCommentForJobApplicantSelector = (state: State, jobApplicantId: number) =>
  state.drafts.commentDrafts.find(
    (d: AutosavedDraft) => d.context.jobApplicantId === jobApplicantId,
  );

export const draftCommentForEmployeeSelector = (state: State, employeeId: number) =>
  state.drafts.commentDrafts.find((d: AutosavedDraft) => d.context.employeeId === employeeId);

export const draftMessageForJobApplicantSelector = (state: State, jobApplicantId: number) =>
  state.drafts.messageDrafts.find(
    (d: AutosavedDraft) => d.context.jobApplicantId === jobApplicantId,
  );

export const draftMessageForEmployeeSelector = (state: State, employeeId: number) =>
  state.drafts.messageDrafts.find((d: AutosavedDraft) => d.context.employeeId === employeeId);
